import { useFundingRequestForm } from "./FundingRequestFormContext";

const money = (cents?: number) =>
  `$${((Number.isFinite(cents) ? (cents as number) : 0) / 100).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`;

export default function SelfFinanceEditConfirmContent() {
  const {
    carrierPay,
    carrierFee,
    brokerCarrierAdvance,
    selfFinanceFee,
    selfFinanceTotalAmount,
    isFetchingCalculation
  } = useFundingRequestForm();

  const rows: Array<[string, number]> = [
    ["Carrier payable", carrierPay],
    ["Carrier QP fee", carrierFee],
    ["Carrier delivery advance", brokerCarrierAdvance],
    ["Self-finance fee", selfFinanceFee],
    ["Self-finance total", selfFinanceTotalAmount]
  ];

  return (
    <span className="block text-left text-sm font-normal">
      <span className="block mb-3">Please review the recomputed amounts before saving:</span>
      <span className="block rounded border border-card divide-y divide-card">
        {rows.map(([label, value]) => (
          <span key={label} className="flex justify-between px-3 py-1.5">
            <span className="text-placeholder">{label}</span>
            <span className="font-medium">{isFetchingCalculation ? "…" : money(value)}</span>
          </span>
        ))}
      </span>
      <span className="block mt-3 text-red-500">
        If you changed the carrier payment speed, the payout clock resets to now (adjustment time),
        so the payout may exceed 30 days.
      </span>
    </span>
  );
}
